/**
 * Frontend fallback for the public home/landing content.
 * Mirrors backend DEFAULT_HOME in /app/backend/site_config.py so the page
 * always renders even if /api/site/home is slow, fails, or hasn't been seeded.
 */
export const DEFAULT_HOME = {
    hero: {
        overline: "Streaming premium de transformação",
        title_pre: "A Nova Era da",
        title_em: "medicina",
        title_post: "começa aqui.",
        subtitle:
            "Jornadas cinematográficas em medicina quântica, consciência e biodescodificação — guiadas por mentores referência. Experimente 7 dias grátis.",
        video_url:
            "/api/uploads/0eaca10df0-hero_faststart.mp4",
        poster_url:
            "https://static.prod-images.emergentagent.com/jobs/e31510f3-0985-434c-b5ba-05b91fac6a7c/images/b9cd90020020879410e044bffec58b1dca27cdb80dc86b72f032bdb76f7ea7f1.png",
        cta_primary_label: "Começar 7 dias grátis",
        cta_primary_href: "/cadastro",
        cta_secondary_label: "Explorar jornadas",
        cta_secondary_href: "/jornadas",
        stats: [
            { label: "Jornadas guiadas", value: "+12" },
            { label: "Certificações", value: "100%" },
            { label: "Conteúdo cinematográfico", value: "4K" },
        ],
    },
    manifesto: {
        enabled: true,
        video_url:
            "/api/uploads/b312210962-manifesto_faststart.mp4",
        quote:
            "“Quando você muda a frequência da sua atenção, o corpo escuta. E a cura encontra rota.”",
        tagline:
            "Instituto de Medicina Quântica — onde o rigor científico encontra a sabedoria contemplativa.",
        cta_label: "Iniciar minha jornada",
        cta_href: "/cadastro",
    },
    featured: {
        eyebrow: "Curadoria do Instituto",
        title: "Jornadas em destaque",
        columns: 4,
    },
    free_section: {
        enabled: true,
        eyebrow: "Área aberta",
        title: "Comece gratuitamente",
    },
};

/** Shallow + per-top-level merge so user-saved fields override defaults safely. */
export function mergeHome(remote) {
    if (!remote || typeof remote !== "object") return DEFAULT_HOME;
    const out = { ...DEFAULT_HOME };
    for (const key of Object.keys(DEFAULT_HOME)) {
        if (remote[key] && typeof remote[key] === "object" && !Array.isArray(remote[key])) {
            out[key] = { ...DEFAULT_HOME[key], ...remote[key] };
        } else if (remote[key] !== undefined) {
            out[key] = remote[key];
        }
    }
    return out;
}
